exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nights-single-flight-info-component[data-v-092ac020]{display:grid;grid-template-columns:1fr 1fr 1fr 1.25fr;gap:.5rem}@media (max-width:768px){.nights-single-flight-info-component[data-v-092ac020]{grid-template-columns:1fr 1fr 1fr}}.nights-single-flight-info-component>div[data-v-092ac020]{overflow:hidden}.nights-single-flight-info-component p[data-v-092ac020]{overflow-wrap:break-word;text-align:center;line-height:1.25}.nights-single-flight-info-component .flight[data-v-092ac020]{display:flex;flex-direction:column;align-self:stretch}.nights-single-flight-info-component .duration[data-v-092ac020]{align-self:center}", ""]);

// exports
